import { render } from "./DrugLook.vue?vue&type=template&id=62299919&scoped=true"
import script from "./DrugLook.vue?vue&type=script&lang=js"
export * from "./DrugLook.vue?vue&type=script&lang=js"

import "./DrugLook.vue?vue&type=style&index=0&id=62299919&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62299919"]])

export default __exports__